import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SignalRServiceService {
  private hubConnection!: signalR.HubConnection;
  public enrollmentLocked$ = new BehaviorSubject<{ projectId: string, participantId: string, lockedBy: string } | null>(null);
  public userConnectionId: string = '';
  private _hubUrl: string = '';

  constructor() {
    this._hubUrl = environment.signalRUrl;
    this.startConnection();
  }

  startConnection() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this._hubUrl}/enrollmentHub`, { withCredentials: true })
      .withAutomaticReconnect()
      .build();

    this.hubConnection.start()
      .then(() => console.log("✅ Conectado a SignalR"))
      .catch(err => console.error("❌ Error al conectar con SignalR", err));

    this.registerSignalRHandlers();
  }

  private registerSignalRHandlers() {
    // 🔹 Guardar el ConnectionId del usuario cuando se conecta
    this.hubConnection.on('ConfirmLock', (connectionId) => {
      console.log("🔹 Mi ConnectionId recibido:", connectionId);
      this.userConnectionId = connectionId;
    });

    // 🔹 Bloqueo recibido de otro usuario
    this.hubConnection.on('LockEnrollment', (projectId, participantId, lockedBy) => {
      console.log("🔴 Bloqueo recibido:", { projectId, participantId, lockedBy });

      // Solo bloqueamos si otro usuario bloqueó esta inscripción
      if (lockedBy !== this.userConnectionId) {
        console.log("⚠️ Bloqueando porque otro usuario está inscribiendo");
        this.enrollmentLocked$.next({ projectId, participantId, lockedBy });
      } else {
        console.log("✅ No me bloqueo a mí mismo");
      }
    });

    // 🔹 Desbloqueo recibido
    this.hubConnection.on('UnlockEnrollment', (projectId, participantId) => {
      console.log("🟢 Desbloqueo recibido:", { projectId, participantId });
      this.enrollmentLocked$.next(null);
    });

    // 🔹 Manejo de reconexión
    this.hubConnection.onreconnecting(() => {
      console.warn("⚠️ Reintentando conectar a SignalR...");
    });

    this.hubConnection.onreconnected(() => {
      console.log("✅ Reconectado a SignalR");
      this.hubConnection.invoke("GetConnectionId").then((connectionId) => {
        console.log("🔄 Reconexión exitosa, nuevo ConnectionId:", connectionId);
        this.userConnectionId = connectionId;
      });
    });

    this.hubConnection.onclose(() => {
      console.error("❌ SignalR desconectado");
    });
  }

  async lockEnrollment(projectId: string, participantId: string): Promise<boolean> {
    await this.ensureConnectionStarted();
    return this.hubConnection.invoke<boolean>("LockEnrollment", projectId, participantId);
  }

  private async ensureConnectionStarted() {
    if (this.hubConnection.state === signalR.HubConnectionState.Disconnected) {
      await this.hubConnection.start().catch(err => console.error(err));
    }
  }

  async checkEnrollmentLock(projectId: string, participantId: string): Promise<boolean> {
    await this.ensureConnectionStarted();
    return this.hubConnection.invoke<boolean>("IsEnrollmentLocked", projectId, participantId);
  }

  unlockEnrollment(projectId: string, participantId: string) {
    if (this.hubConnection.state === signalR.HubConnectionState.Connected) {
      console.log("🟢 Desbloqueando inscripción en el servidor...");
      this.hubConnection.invoke("UnlockEnrollment", projectId, participantId)
        .catch(err => console.error("❌ Error al desbloquear inscripción:", err));
    }
  }
}
